module.exports = __webpack_public_path__ + "static/icons/icon-atento-actualizar.c715975.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/icon-atento-actualizar.svg
// module id = 4oCB
// module chunks = 1